/** @file groupCounts: how many nodes sit in each hit/fade group 1-7 (the filter chips' counts). */
import type { PuppetNode } from '@zilo/pose3d-format/types/puppet';

/** Counts for groups 1..7 (index 0 = group 1); nodes without a group are not counted. */
export function groupCounts(nodes: Record<string, PuppetNode>): number[] {
  const counts = [0, 0, 0, 0, 0, 0, 0];
  for (const node of Object.values(nodes)) {
    if (node.group !== undefined) counts[node.group - 1] = (counts[node.group - 1] ?? 0) + 1;
  }
  return counts;
}
